import { PaymentWhereInput } from '../../../__generated__/graphql';
import SearchField from '../../../@types/SearchField';

const PAYMENTS_TABLE_SEARCH_FIELDS: SearchField<PaymentWhereInput>[] = [];

export default PAYMENTS_TABLE_SEARCH_FIELDS;
